import axios from "axios";

// Production uses the same public origin for the dashboard and API.  Keeping
// this relative avoids baking a preview/development domain into the bundle.
const API_ORIGIN = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/$/, "");
const BASE = `${API_ORIGIN}/api/v1`;

let accessToken = null;
let onLogout = null;
let authVersion = 0;

export const setAccessToken = (t) => { authVersion++; accessToken = t; };
export const getAccessToken = () => accessToken;
export const setLogoutHandler = (fn) => { onLogout = fn; };

export const api = axios.create({ baseURL: BASE, withCredentials: true });

api.interceptors.request.use((config) => {
  const path = (config.url || "").split(/[?#]/)[0];
  if (/\/orgs\/(?:\s*\/|(?:undefined|null)(?:\/|$)|$)/.test(path)) {
    return Promise.reject(new Error("Select an organization before continuing."));
  }
  if (accessToken) config.headers.Authorization = `Bearer ${accessToken}`;
  return config;
});

let refreshing = null;

async function doRefresh() {
  if (!refreshing) {
    const version = authVersion;
    refreshing = axios
      .post(`${BASE}/auth/refresh`, {}, { withCredentials: true })
      .then((r) => {
        if (version !== authVersion) throw Object.assign(new Error("Authentication changed during refresh"), { code: "AUTH_CHANGED" });
        accessToken = r.data.access_token;
        return r.data;
      })
      .catch((error) => {
        if (version !== authVersion) throw Object.assign(new Error("Authentication changed during refresh"), { code: "AUTH_CHANGED" });
        throw error;
      })
      .finally(() => { refreshing = null; });
  }
  return refreshing;
}

api.interceptors.response.use(
  (r) => r,
  async (error) => {
    const original = error.config;
    const url = original?.url || "";
    const isAuthRoute = ["/auth/login", "/auth/register", "/auth/refresh", "/auth/logout"].some((path) => url.includes(path));
    if (original && error.response?.status === 401 && !original._retry && !isAuthRoute) {
      original._retry = true;
      try {
        await doRefresh();
        original.headers.Authorization = `Bearer ${accessToken}`;
        return api(original);
      } catch (e) {
        if (e.code === "AUTH_CHANGED") return Promise.reject(e);
        accessToken = null;
        if (onLogout) onLogout();
        return Promise.reject(e);
      }
    }
    return Promise.reject(error);
  },
);

export function apiError(e, fallback = "Something went wrong") {
  const d = e?.response?.data?.detail;
  if (d == null) return e?.message || fallback;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  if (typeof d?.msg === "string") return d.msg;
  return String(d);
}

export { doRefresh };
